import { render, staticRenderFns } from "./FiberComingSoon.vue?vue&type=template&id=7bac3e4f&scoped=true&"
import script from "./FiberComingSoon.vue?vue&type=script&lang=ts&"
export * from "./FiberComingSoon.vue?vue&type=script&lang=ts&"
import style0 from "./FiberComingSoon.vue?vue&type=style&index=0&id=7bac3e4f&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bac3e4f",
  null
  
)

export default component.exports